interface Step {
  title: string;
  description: string;
}

interface ProcessStepsProps {
  steps: Step[];
  layout?: "vertical" | "horizontal";
}

const ProcessSteps = ({ steps, layout = "vertical" }: ProcessStepsProps) => {
  if (layout === "horizontal") {
    return (
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
        {steps.map((step, i) => (
          <div key={i} className="relative">
            <span className="block font-headline text-4xl text-accent/30 mb-3">
              {String(i + 1).padStart(2, "0")}
            </span>
            <h3 className="font-headline text-lg md:text-xl text-foreground mb-2">{step.title}</h3>
            <p className="text-muted-foreground text-sm leading-relaxed">{step.description}</p>
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className="max-w-2xl mx-auto space-y-10">
      {steps.map((step, i) => (
        <div key={i} className="flex gap-6">
          <div className="flex-shrink-0 w-12 text-right">
            <span className="font-headline text-3xl text-accent/30">
              {String(i + 1).padStart(2, "0")}
            </span>
          </div>
          <div className="pt-1">
            <h3 className="font-headline text-lg md:text-xl text-foreground mb-2">{step.title}</h3>
            <p className="text-muted-foreground text-sm leading-relaxed">{step.description}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ProcessSteps;
